export const SET_IS_CAMERA_REQUIRED = "SET_IS_CAMERA_REQUIRED";

export const SET_WEBCAM_STREAM = "SET_WEBCAM_STREAM";

export const SET_CAMERA_STATUS = "SET_CAMERA_STATUS";

export const SET_CAMERA_ERROR = "SET_CAMERA_ERROR";
